/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — spelling out the amount in words is exactly what cheques, invoices and legal forms require. Copy the words straight into your document.`)
};

const es_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — deletrear el monto en palabras es exactamente lo que requieren los cheques, facturas y formularios legales. Copia las palabras directamente en tu documento.`)
};

const de_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — den Betrag in Worten auszuschreiben ist genau das, was Schecks, Rechnungen und rechtliche Formulare verlangen. Kopieren Sie die Worte direkt in Ihr Dokument.`)
};

const nl_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — het uitschrijven van het bedrag in woorden is precies wat cheques, facturen en juridische formulieren vereisen. Kopieer de woorden rechtstreeks naar uw document.`)
};

const fr_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — écrire le montant en lettres est exactement ce que nécessitent les chèques, factures et documents juridiques. Copiez les lettres directement dans votre document.`)
};

const it_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — scrivere l'importo in parole è esattamente quello che gli assegni, le fatture e i moduli legali richiedono. Copia le parole direttamente nel tuo documento.`)
};

const pt_br2_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — escrever o valor em palavras é exatamente o que cheques, notas fiscais e formulários legais exigem. Copie as palavras direto para seu documento.`)
};

const pt_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — soletrar o valor em palavras é exactamente o que cheques, faturas e formulários legais exigem. Copie as palavras diretamente para o seu documento.`)
};

const ja_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。金額を単語で綴ることは、小切手、請求書、法的形式が正確に要求していることです。単語をドキュメントに直接コピーしてください。`)
};

const zh_nw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的——用文字拼写出金额正是支票、发票和法律表格所要求的。直接将文字复制到你的文档中即可。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq3_a", locale)
	if (locale === "en") return en_nw_faq3_a(inputs)
	if (locale === "es") return es_nw_faq3_a(inputs)
	if (locale === "de") return de_nw_faq3_a(inputs)
	if (locale === "nl") return nl_nw_faq3_a(inputs)
	if (locale === "fr") return fr_nw_faq3_a(inputs)
	if (locale === "it") return it_nw_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq3_a(inputs)
	if (locale === "pt") return pt_nw_faq3_a(inputs)
	if (locale === "ja") return ja_nw_faq3_a(inputs)
	return zh_nw_faq3_a(inputs)
};